
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BaseFieldQuantity extends Vue {
  @Prop(String)
  value!: string;

  @Prop({ type: Number, default: 99999 })
  max!: number;

  min = 0;

  clamped = false;

  onInput(event: any) {
    const newValue = parseInt(event.target.value, 10) || 0;
    const clampedValue = Math.max(Math.min(newValue, this.max), this.min) || 0;
    this.$emit('input', clampedValue);
    if (clampedValue !== newValue) {
      this.clamped = true;
      setTimeout(() => {
        this.clamped = false;
      }, 600);
    } else {
      this.clamped = false;
    }
    this.$forceUpdate();
  }
}
